"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement("path", { d: "M9 18L15 12L9 6", stroke: "currentColor", strokeWidth: "1.5", strokeLinejoin: "round" }));
